import React, { useRef, useState, useEffect } from 'react';
import { default as ReelPlay } from '../../../images/Reel_Play_Icon.svg';
import CommunityImg from '../CommunityImg/CommunityImg';

const ReelVideo = ({
  item
}) => {

  const childRefs = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(()=>{
    document.body.addEventListener('click', pauseVideo);
    if (window.innerWidth < 768) setIsMobile(true);
    return ()=>{
      document.body.removeEventListener('click', pauseVideo);
    }
  },[]);

  const pauseVideo = (e) => {
    const {target} = e;
    if(!childRefs.current.contains(target)) {
      if(!childRefs.current?.childNodes[0].paused) {
        childRefs.current?.childNodes[0].pause();
        setIsPlaying(false);
      }
    }
  }

  const playReelVideo = () => {
    childRefs.current?.childNodes[0].play();
    setIsPlaying(true);
  }

  const pauseReelVideo = () => {
    childRefs.current?.childNodes[0].pause();
    setIsPlaying(false);
  }

  return (
    <div className="eco-alliance-join-reel-item" role="presentation" ref={childRefs}>
      <video
        src={`${item.node.videoUrl.file.url}#t=0.001`}
        alt="eco reel video"
        preload="metadata"
        playsInline
        onClick={() => childRefs.current?.childNodes[0].paused ? playReelVideo() : pauseReelVideo()}
        loop />
      <CommunityImg
        className={`play-button ${childRefs.current?.childNodes[0] && !childRefs.current?.childNodes[0].paused && !isMobile && 'playing'}`}
        src={ReelPlay}
        alt="Reel Play"
        onClick={() => { childRefs.current?.childNodes[0].paused ? playReelVideo() : pauseReelVideo() }}
      />
    </div>
  )
}

export default ReelVideo;